import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { CircleCheckIcon } from '../atoms';
export const ToastMessage = {
    breakfast: 'breakfast',
    lunch: 'lunch',
    dinner: 'dinner',
    snacking: 'snacking',
    liveLesson: 'liveLesson',
    weight: 'weight',
    stepGoal: 'stepGoal',
    workoutGoal: 'workoutGoal',
};
const ToastMessageText = {
    [ToastMessage.breakfast]: '朝食の入力が完了しました！🎉',
    [ToastMessage.lunch]: '昼食の入力が完了しました！🎉',
    [ToastMessage.dinner]: '夕食の入力が完了しました！🎉',
    [ToastMessage.snacking]: '間食の入力が完了しました！🎉',
    [ToastMessage.liveLesson]: 'LIVEレッスンの視聴が完了しました！🎉',
    [ToastMessage.weight]: '体重入力が完了しました！🎉',
    [ToastMessage.stepGoal]: 'ウォーキング目標を達成しました！🎉',
    [ToastMessage.workoutGoal]: 'ワークアウト目標を達成しました！🎉',
};
const TOAST_HIDDEN_TIME = 3000; // ms
const TOAST_HIDDEN_TIME_BUFFER = 1000;
export const Toast = ({ message, onClose }) => {
    React.useEffect(() => {
        const timer = setTimeout(onClose, TOAST_HIDDEN_TIME + TOAST_HIDDEN_TIME_BUFFER);
        return () => clearTimeout(timer);
    }, []);
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.iconWrapper) },
            React.createElement(CircleCheckIcon, { filled: true, color: Colors.ProgressGreen, fillColor: Colors.White, classObject: styles.icon })),
        React.createElement("span", { className: css(styles.message) }, ToastMessageText[message])));
};
const toastSlideFadeAnimation = {
    '0%': {
        opacity: 0,
        transform: 'translateY(-20px)',
    },
    '6.7%': {
        opacity: 1,
        transform: 'translateY(0)',
    },
    '90%': {
        opacity: 1,
        transform: 'translateY(0)',
    },
    '100%': {
        opacity: 0,
        transform: 'translateY(-20px)',
    },
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        color: Colors.White,
        backgroundColor: Colors.PrimaryDark,
        padding: '12px 14px',
        marginBottom: 14,
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
        animationName: [toastSlideFadeAnimation],
        animationDuration: `${TOAST_HIDDEN_TIME}ms`,
        animationTimingFunction: 'ease',
        animationFillMode: 'both',
        willChange: 'opacity, transform',
    },
    iconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        width: 22,
        height: 22,
        border: `1px solid ${Colors.White}`,
        borderRadius: 30,
    },
    message: {
        fontSize: 13,
        fontWeight: 'bold',
        letterSpacing: 1.04,
        lineHeight: '100%',
    },
});
